module.exports = __webpack_public_path__ + "static/media/fort_myers_team.20c03924.jpg";